import { API_PATHS, USE_MOCK } from '../config';
import { request } from './client';
import { unwrapApiData } from '../utils/apiResponse';

const DEFAULT_FEATURES = {
  featureFixedDurationSegment: false,
  featureHighlightAsr: false,
};

/**
 * 公开功能开关（无需登录）
 * @returns {Promise<{ featureFixedDurationSegment: boolean, featureHighlightAsr: boolean }>}
 */
export async function fetchPublicFeatures() {
  if (USE_MOCK) {
    return { ...DEFAULT_FEATURES };
  }
  try {
    const data = unwrapApiData(await request(API_PATHS.features));
    return {
      featureFixedDurationSegment: !!(data && data.featureFixedDurationSegment),
      featureHighlightAsr: !!(data && data.featureHighlightAsr),
    };
  } catch (e) {
    return { ...DEFAULT_FEATURES };
  }
}
